import { Module } from '../types/moduleModel';
import axios, { AxiosResponse } from 'axios';

/**
 * @returns {Promise<Module[]>}
 */
export async function apiUpdateModule(moduleId: string, data: any): Promise<Module> {
  const response: AxiosResponse = await axios.post('/api/modules/' + moduleId, data);
  return response.data;
}